import { useRef } from 'react';
import DOMPurify from 'dompurify';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { useHoverableTooltip, Tag, TagColor, Icon, IconSize, Popover } from '@shipengine/giger';
import { getNotificationStyles, getTextStyles, getInfoIconStyles } from './ServiceNotificationStyles.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';

const ServiceNotification = _ref => {
  let {
    icon,
    textKey,
    tagKey,
    popoverContent
  } = _ref;
  const {
    t
  } = useTranslation();
  const reference = useRef(null);
  const {
    opened: isPopoverOpened
  } = useHoverableTooltip(reference);
  return jsxs("article", {
    css: getNotificationStyles,
    children: [tagKey && jsx(Tag, {
      color: TagColor.SECONDARY,
      children: t(tagKey)
    }), icon && jsx(Icon, {
      name: icon
    }), jsx("span", {
      css: getTextStyles,
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(t(textKey))
      }
    }), popoverContent && jsxs(Fragment, {
      children: [jsx("div", {
        ref: reference,
        children: jsx(Icon, {
          name: IconNames.INFO,
          size: IconSize.SIZE_SMALL,
          css: getInfoIconStyles
        })
      }), jsx(Popover, {
        reference: reference.current,
        placement: "bottom-end",
        isOpen: isPopoverOpened
        // Since the width of the icon is small, the Popover can't position correctly the arrow
        // under it, so we need to "manually" move the Popover
        ,
        offset: 13,
        children: popoverContent
      })]
    })]
  });
};

export { ServiceNotification };
//# sourceMappingURL=ServiceNotification.js.map
